import { render, staticRenderFns } from "./QuestionsList.vue?vue&type=template&id=99f01270&scoped=true"
import script from "./QuestionsList.vue?vue&type=script&lang=ts"
export * from "./QuestionsList.vue?vue&type=script&lang=ts"
import style0 from "./QuestionsList.vue?vue&type=style&index=0&id=99f01270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f01270",
  null
  
)

export default component.exports